import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextToSpeach: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextToSpeach"><Path d="M11.5 14.5V17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 7.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 10.5V17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 12.5V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 5.5V3.5H8M12.5 5.5V3.5H8M8 3.5V12.5M8 12.5H6M8 12.5H10" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTextToSpeach;
